// src/pages/nosotros/Historia.jsx

const Historia = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24">
      
      {/* Hero Section (Solemne e Histórico) */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "src'/granmaestro.jpg'" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Nosotros
          </p>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-8">
            Breve Historia de la Fundación
          </h1>
          
          {/* Botón de Descarga PDF Premium */}
          <a 
            href="/historia_glp.pdf" // Asegúrate de colocar el PDF real en la carpeta public
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-3 border border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-[#050505] transition-all duration-500 text-xs tracking-[0.2em] uppercase animate-fade-in [animation-delay:0.6s]"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Descarga en PDF
          </a>
        </div>
      </section>

      {/* Cuerpo Editorial (Diseño optimizado para lectura larga) */}
      <section className="relative z-20 max-w-4xl mx-auto px-6 lg:px-12 py-16 md:py-24">
        <div className="prose prose-invert prose-lg md:prose-xl max-w-none text-gray-300 font-light leading-relaxed text-justify">
          
          <p className="mb-8">
            <span className="float-left text-7xl md:text-8xl text-[#C5A059] font-serif pr-4 leading-[0.8] mt-2 drop-shadow-md">
              L
            </span>
            as primeras Logias de que se tienen noticias en el Perú en la época de nuestra independencia, lo hicieron bajo la jurisdicción del GRAN ORIENTE NACIONAL DE COLOMBIA. Ocurrida la disolución de la GRAN COLOMBIA como consecuencia de la crisis política de 1828, se constituyó la República de NUEVA GRANADA que ahora se llama COLOMBIA.
          </p>

          <p className="mb-8">
            Esta disolución hizo que la Logias del Perú creyeran que con la GRAN COLOMBIA había desaparecido también el GRAN ORIENTE NACIONAL DE COLOMBIA, por lo que consideraron necesario formar un gobierno del Rito Escocés, propio e independiente para la República del Perú.
          </p>

          <p className="mb-12">
            Fue así cómo, 9 Ilustres hermanos del Grº 33, se reunieron en Lima bajo la presidencia accidental del más antiguo de ellos, el Presbítero Dr. Don JOSÉ MARIA MONZÓN, Ex Capellán del Ejército Libertador, y el <strong>02 de noviembre de 1830 fundaron el SUPREMO CONSEJO DEL PERÚ</strong>, recayendo en el Hermano, General DOMINGO TRISTAN el cargo de Soberano Gran Comendador, y el <strong>23 de junio de 1831 se fundó la primera GRAN LOGIA DEL PERÚ</strong>, teniendo en el cargo de Gran Maestro al H.·. TOMAS RIPLEY ELDERDGE.
          </p>

          <h3 className="font-serif text-2xl md:text-3xl text-white mb-6 border-b border-white/10 pb-4">
            El Caos y el Resurgimiento
          </h3>

          <p className="mb-6">
            El 11 de agosto del mismo año 1831 cambiaron el nombre de GRAN LOGIA DEL PERÚ al de GRAN ORIENTE PERUANO, y trabajaron, tanto el SUPREMO CONSEJO como el GRAN ORIENTE PERUANO, armónicamente en el Rito Escocés Antiguo y Aceptado.
          </p>

          <p className="mb-4 text-[#C5A059] uppercase tracking-widest text-sm font-medium">Hasta el año de 1833 existían 7 Logias:</p>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 mb-8 text-gray-400 text-base border-l-2 border-[#C5A059]/30 pl-6 list-none">
            <li>• Paz y Perfecta Unión</li>
            <li>• Orden y Libertad</li>
            <li>• Virtud y Unión</li>
            <li>• Constancia Peruana</li>
            <li>• Sol de Huayna Cápac</li>
            <li>• Unión Justa</li>
            <li>• Orden y Reforma</li>
          </ul>

          <p className="mb-8">
            El caos político que imperó en el Perú el año de 1833 obligó al cierre del SUPREMO CONSEJO DEL PERÚ y del GRAN ORIENTE PERUANO, así como al abatimiento de columnas por 12 largos años, de las 7 Logias existentes.
          </p>

          <p className="mb-12">
            El 06 de noviembre de 1844 se reinstala ORDEN Y LIBERTAD Nº 2; el 11 de noviembre de 1848 se restablece el GRAN ORIENTE PERUANO, y el SUPREMO CONSEJO DEL PERÚ lo hace el 20 de enero de 1849; VIRTUD Y UNIÓN se reinstala recién el 12 de setiembre de 1855.
          </p>

          <div className="bg-[#0a0a0a] p-8 md:p-10 border border-white/5 mb-12 relative overflow-hidden">
             <div className="absolute top-0 right-0 w-32 h-32 bg-[#C5A059] opacity-5 rounded-bl-full"></div>
             <h4 className="font-serif text-xl text-white mb-4">El Rito de York en el Perú</h4>
             <p className="text-base text-gray-400 m-0">
               En 1852 vemos la aparición en el Perú del RITO DE YORK, con el Cuerpo Masónico denominado CAPÍTULO REAL ARCO ESTRELLA BOREAL Nº 74 en el Valle del CALLAO, con Carta Constitutiva expedida por el SOBERANO CAPÍTULO DEL REAL ARCO DE ESCOCIA. Pero las huellas de este Cuerpo se perdieron hasta el 19 de diciembre de 1875, en que apareció trabajando con el nombre de ALIANZA Y FIRMEZA Nº 161.
             </p>
          </div>

          <h3 className="font-serif text-2xl md:text-3xl text-white mb-6 border-b border-white/10 pb-4">
            La Convención de Lausana y el Conflicto
          </h3>

          <p className="mb-8">
            No cabe duda que el Ilustre y Poderoso Hermano ANTONIO DE SOUZA FERREYRA, quien fue Soberano Comendador del SUPREMO CONSEJO DEL PERÚ en el año de 1856, adelantándose a esta época, había iniciado y promovido la CONVENCIÓN DE LAUSANA (1875). Quedaron establecidas dos normas muy importantes:
          </p>

          <ul className="space-y-4 mb-12 text-base text-gray-300 list-decimal pl-6 marker:text-[#C5A059]">
            <li className="pl-2">Que los SUPREMOS CONSEJOS DEL MUNDO abandonen los derechos que les otorgaban las CONSTITUCIONES DE 1786, de gobernar a las Logias Simbólicas, reconociendo a las Grandes Logias el derecho a gobernarlas.</li>
            <li className="pl-2">Se estableció la DEMARCACIÓN TERRITORIAL de cada CONSEJO SUPREMO coincidente con la de su Nación o Estado (Territorio Ocupado o Desocupado).</li>
          </ul>

          <p className="mb-8">
            Y así llegamos al año de 1879, en el que se inicia la infausta guerra de Chile contra el Perú y Bolivia, de funestas consecuencias para estos dos países, consecuentemente para la Francmasonería.
          </p>

          <h3 className="font-serif text-2xl md:text-3xl text-white mb-6 border-b border-white/10 pb-4">
            Virtud y Unión Nº 3, Gestora de la Gran Logia
          </h3>

          <p className="mb-8">
            En Diciembre del 1881, el Supremo Consejo emite un Decreto que sembró estupor y vino a constituir <strong>EL DETONANTE</strong> para la formación de la GRAN LOGIA DEL PERÚ. El 12 de diciembre, la R.·. L.·. S.·. VIRTUD Y UNIÓN Nº 3, presidida por su V.·. M.·. el R.·. H.·. JULIO FRANCISCO DE IRIARTE, cursa a las Logias Simbólicas una Plancha pidiendo su valioso apoyo:
          </p>

          <blockquote className="border-l-4 border-[#C5A059] bg-[#0a0a0a] p-6 text-gray-400 italic mb-12 text-base md:text-lg">
            "...la formación inmediata de la GRAN LOGIA DEL PERÚ... por la que me dirijo a Vos, a fin de que interponiendo vuestra influencia, obtengáis que vuestra Logia se adhiera a este grandioso pensamiento que preocupa a todos los verdaderos Masones".
          </blockquote>

          <h3 className="font-serif text-2xl md:text-3xl text-white mb-6 border-b border-white/10 pb-4">
            La Convención y la Instalación (1882)
          </h3>

          <p className="mb-8">
            El 05 de Marzo de 1882 son convocadas a una CONVENCIÓN las Logias de la República. Trabajan en forma continua durante 14 días formulando la CONSTITUCIÓN, los ESTATUTOS, diseñando los SELLOS y eligiendo al <strong>PRIMER GRAN MAESTRO DE MASONES DEL PERÚ</strong>, importantísimo cargo que recae en el R.·.H.·. ANTONIO ARENAS MERINO.
          </p>

          <p className="mb-12">
            El 25 de Marzo se reunieron en el Templo de la Fraternidad (Callejón de San Francisco Nº 27). Cuando el Templo albergaba ya unos 500 hermanos en un ambiente de solemnidad y devoción, el Presidente dio lectura a una MEMORIA que relató el origen del Movimiento Liberal, invitando al I.·.P.·.H.·. HARTLEY a proceder a la INSTALACIÓN DEL GRAN MAESTRO, y la GRAN LOGIA DEL PERÚ fue declarada ABIERTA EN FORMA AMPLIA.
          </p>

          <h3 className="font-serif text-2xl md:text-3xl text-white mb-6 border-b border-white/10 pb-4">
            Conclusiones y Homenaje
          </h3>

          <p className="mb-8">
            Esta es QQ.·. y RR.·. HH.·. la historia resumida del POR QUÉ, el CÓMO y del PARA QUÉ se fundó la GRAN LOGIA DEL PERÚ, única Potencia Masónica investida de PODER para gobernar y administrar a todas las LOGIAS SIMBÓLICAS DEL ORIENTE DEL PERÚ.
          </p>

          <p className="mb-8">
            Su GESTOR y FUNDADOR, el R.·.H.·. JULIO FRANCISCO DE IRIARTE, recibió los honores que merecía a los 100 años de su pase al Oriente Eterno. En el año 1,998, centenario de su fallecimiento, se le confirió póstumamente el Título Honorífico de <strong>“GRAN MAESTRO DE MASONES DE LA GRAN LOGIA DEL PERÚ” - EMÉRITO</strong>.
          </p>

          <div className="text-center mt-16 border-t border-white/10 pt-12">
            <p className="text-[#C5A059] font-serif italic text-xl mb-4">
              "Que el G.·.A.·.D.·.U.·. tenga en su seno al M.·.R.·.H.·.G.·.M.·.E.·. JULIO FRANCISCO DE IRIARTE por toda la eternidad, así como nosotros lo llevamos en nuestros corazones por siempre."
            </p>
            <div className="text-sm text-gray-500 uppercase tracking-widest mt-8">
              <p>Vall.·. de Lima, 12 de setiembre del 2006, E.·.V.·.</p>
              <p className="mt-2 text-white">R.·.H.·. Virgilio Gonzales Ramírez</p>
              <p>P.·.V.·.M.·. de la R.·.L.·.S.·. Virtud y Unión Nº 3</p>
            </div>
          </div>

          {/* Bibliografía */}
          <div className="mt-24 bg-[#0a0a0a] p-8 border border-white/5">
            <h5 className="text-[#C5A059] uppercase tracking-widest text-xs font-semibold mb-6">Bibliografía</h5>
            <ul className="text-sm text-gray-500 space-y-4 list-none m-0 p-0">
              <li>
                <strong className="text-gray-300">Historia de la Fundación de la Gran Logia del Perú</strong><br/>
                Publicada por la Gran Logia del Perú (DECRETO DE G.·.M.·. Nº 164-81. Vall.·. Lima, 11 mayo 1981).
              </li>
              <li>
                <strong className="text-gray-300">Apuntes Sobre la Historia de la Francmasonería Peruana</strong><br/>
                R.·.H.·. Abel Contreras Gonzales, R.·.L.·.S.·. Arca de Noé Nº 8 (23 mayo 1995).
              </li>
              <li>
                <strong className="text-gray-300">Convento Universal de los Supremos Consejos del Rito Escocés Antiguo y Aceptado</strong><br/>
                Lausana – Suiza (06 al 22 setiembre 1875).
              </li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Historia;